(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aigloble-shared"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aigloble-video-slider')) {
    customElements.define('aigloble-video-slider', class extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('.aigloble-hero__videos');
        if (!this.row) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous = this.querySelector('[data-video-previous]');
        this.next = this.querySelector('[data-video-next]');
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.row.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.row.addEventListener('keydown', event => {
          if (event.target !== this.row || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.aigloble-hero__card');
          if (card && this.row.contains(card)) this.row.scrollTo({ left: card.offsetLeft - this.row.firstElementChild.offsetLeft, behavior: 'instant' });
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.row);
        this.update();
      }
      move(direction) {
        const cards = this.row.children;
        if (cards.length < 2) return;
        const step = cards[1].offsetLeft - cards[0].offsetLeft;
        this.row.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        if (this.previous) this.previous.disabled = this.row.scrollLeft <= 1;
        if (this.next) this.next.disabled = this.row.scrollLeft >= this.row.scrollWidth - this.row.clientWidth - 1;
      }
      disconnectedCallback() { this.events?.abort(); this.resizeObserver?.disconnect(); }
    });
  }
  if (!customElements.get('aigloble-video')) {
    customElements.define('aigloble-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.playButton = this.querySelector('[data-video-play]');
        this.soundButton = this.querySelector('[data-video-sound]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.visible = false;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.autoplay = false;
        this.video.pause();
        this.playButton?.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.video.paused) this.play();
          else this.video.pause();
        }, options);
        this.soundButton?.addEventListener('click', () => {
          const unmute = this.video.muted;
          document.querySelectorAll('aigloble-video video').forEach(video => { video.muted = true; });
          this.video.muted = !unmute;
          if (unmute && this.video.paused) { this.userPaused = false; this.play(); }
        }, options);
        ['play', 'pause', 'volumechange', 'error'].forEach(event => this.video.addEventListener(event, () => this.update(), options));
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
          if (this.visible && this.dataset.autoplay === 'true' && !this.userPaused && !this.reducedMotion.matches && !document.hidden) this.play();
          else if (!this.visible) this.video.pause();
        }, { threshold: [0, .5] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else if (this.visible && this.dataset.autoplay === 'true' && !this.userPaused && !this.reducedMotion.matches) this.play();
        }, options);
        this.update();
      }
      play() { this.video.play().catch(() => this.update()); }
      update() {
        const playing = !this.video.paused;
        if (this.playButton) {
          this.playButton.setAttribute('aria-label', playing ? this.playButton.dataset.pauseLabel : this.playButton.dataset.playLabel);
          this.playButton.setAttribute('aria-pressed', String(playing));
          this.playButton.querySelector('[data-icon-play]').hidden = playing;
          this.playButton.querySelector('[data-icon-pause]').hidden = !playing;
        }
        if (this.soundButton) {
          this.soundButton.setAttribute('aria-label', this.video.muted ? this.soundButton.dataset.unmuteLabel : this.soundButton.dataset.muteLabel);
          this.soundButton.setAttribute('aria-pressed', String(!this.video.muted));
          this.soundButton.querySelector('[data-icon-muted]').hidden = !this.video.muted;
          this.soundButton.querySelector('[data-icon-sound]').hidden = this.video.muted;
        }
      }
      disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); this.video?.pause(); }
    });
  }
  if (!customElements.get('aigloble-marquee')) {
    customElements.define('aigloble-marquee', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.button = this.querySelector('[data-marquee-pause]');
        this.button?.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
          this.button.querySelector('[data-icon-play]').hidden = !paused;
          this.button.querySelector('[data-icon-pause]').hidden = paused;
        }, { signal: this.events.signal });
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
